import Box from "@mui/material/Box";
import Txt from "../typography/Txt";
import Flx from "../layout/Flx";

/**
 * Yes/No pill switch — the control used across the Loan Info redesign tab,
 * lifted out so every Rff boolean switch renders the same thing.
 *
 * Presentational only: pass `checked` + `onChange(nextValue)`. The whole row
 * (label included) is the hit target, matching the redesign's behavior.
 *
 * Colors are the redesign tab's tokens (T.value / T.muted / T.focus).
 */

const ON_COLOR = "#06b6d4";
const OFF_TRACK = "#e2e8f0";
const TEXT_ON = "#0f172a";
const TEXT_OFF = "#94a3b8";

const YesNoSwitch = ({
  checked,
  onChange,
  disabled = false,
  hideLabel = false,
  activeColor = ON_COLOR,
  sx,
}) => {
  const on = !!checked;

  return (
    <Flx
      ac
      g={1.25}
      onClick={() => {
        if (disabled) return;
        onChange?.(!on);
      }}
      sx={{
        cursor: disabled ? "default" : "pointer",
        userSelect: "none",
        opacity: disabled ? 0.5 : 1,
        px: 0.5,
        py: 0.5,
        ...sx,
      }}
    >
      {!hideLabel && (
        <Txt
          sx={{
            fontSize: 13,
            width: 26,
            textAlign: "right",
            fontWeight: on ? 600 : 400,
            color: on ? TEXT_ON : TEXT_OFF,
          }}
        >
          {on ? "Yes" : "No"}
        </Txt>
      )}
      <Box
        sx={{
          position: "relative",
          width: 36,
          height: 20,
          borderRadius: 999,
          flexShrink: 0,
          transition: "background .15s",
          background: on ? activeColor : OFF_TRACK,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 2,
            left: on ? 18 : 2,
            width: 16,
            height: 16,
            borderRadius: "50%",
            background: "#fff",
            boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
            transition: "left .15s",
          }}
        />
      </Box>
    </Flx>
  );
};

export default YesNoSwitch;
